import { render } from "./ApprovalsByMonthPanel.vue?vue&type=template&id=ab4f88fe"
import script from "./ApprovalsByMonthPanel.vue?vue&type=script&lang=js"
export * from "./ApprovalsByMonthPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__